import { INITIAL_COMPANY_DATA } from '../constants.js';

export const createUpdateFormData = (setFormData) => (field, value) => {
    if (field?.includes('.')) {
        const [parent, child] = field.split('.');
        setFormData((prev) => ({
            ...prev,
            [parent]: {
                ...prev[parent],
                [child]: value,
            },
        }));
    } else {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    }
};

export const createUpdateMultipleFields = (setFormData) => (updates) => {
    setFormData((prev) => ({
        ...prev,
        ...updates,
    }));
};

export const createResetForm =
    (setFormData, initialData = {}) =>
    () => {
        setFormData({
            ...INITIAL_COMPANY_DATA,
            ...initialData,
        });
    };

export const getInitialFormData = (initialData = {}) => ({
    ...INITIAL_COMPANY_DATA,
    ...initialData,
});

// The backend rejects an empty Data Processing Region (engineLocations) with
// a plain { message } body rather than a field-level errors map.
export const getEngineLocationsErrorMessage = (error) => {
    const message = error?.response?.data?.message || '';
    return /engine location/i.test(message) ? message : null;
};
